import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted } from "vue";
import { DataTableHeader } from "vuetify";
import ApprovalChip from "@/components/approval/table/ApprovalChip.vue";
import { Shozoku } from "@/models/transaction/Shozoku";
import DatePicker from "@/components/picker/DatePicker.vue";
import { Paths } from "@/plugins/api/paths";
import { $get } from "@/plugins/api/api";
import { EnumApprovalState, EnumCheckApproval } from "@/models/enum/Enum";
import { CheckApprovalSearchRequest } from "@/models/approval/ApprovalRequest";
import { CheckApproval } from "@/models/approval/ApprovalResponse";
import CheckApprovalChip from "../approval/table/CheckApprovalChip.vue";
import { DateTime } from "luxon";

type Props = {
  form: CheckApprovalSearchRequest;
  items: CheckApproval[];
  headers: DataTableHeader[];
  title: string;
  itemKey: string;
};
type Emits = {
  (e: "update:form", value: CheckApprovalSearchRequest): void;
  (e: "search"): void;
  (e: "check", value: number[]): void;
};

type ClickRowSlot = {
  expand: (value: boolean) => void;
  headers: DataTableHeader[];
  isExpanded: boolean;
  isMobile: boolean;
  isSelected: boolean;
  item: unknown;
  select: (value: boolean) => void;
};

type Item = {
  text: string;
  value: number;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckApprovalTableBase',
  props: {
    form: null,
    items: null,
    headers: null,
    title: null,
    itemKey: null
  },
  emits: ["update:form", "search", "check"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: "update:form", value: CheckApprovalSearchRequest): void;
  (e: "search"): void;
  (e: "check", value: number[]): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  form: CheckApprovalSearchRequest;
  items: CheckApproval[];
  headers: DataTableHeader[];
  title: string;
  itemKey: string;
};




//v-data-table
const selected = ref<CheckApproval[]>([]);
const expanded = ref<CheckApproval[]>([]);
const itemClass = (item?: CheckApproval) =>
  expanded.value.some(e => e.recordId === item?.recordId)
    ? "yellow accent-1"
    : "";

//検索フォーム
const modelForm = computed({
  get: () => props.form,
  set: (v: CheckApprovalSearchRequest) => emits("update:form", v)
});
const employeeItems = ref<Item[]>([]);
const affiliationItems = ref<Shozoku[]>([]);

//共通ヘッダー
const defaultHeaders: DataTableHeader[] = [
  {
    text: "確認",
    value: "check",
    align: "center",
    sortable: false,
    divider: true,
    width: 50
  },
  { text: "", value: "data-table-expand" }
];
const computedHeaders = computed(() => [...props.headers, ...defaultHeaders]);

const approvalItems = [
  { text: "未承認", value: EnumApprovalState.UNAPPROVAL },
  { text: "承認", value: EnumApprovalState.RESOLVE },
  { text: "却下", value: EnumApprovalState.REJECT },
  { text: "承認中", value: EnumApprovalState.DURING }
] as const;

const checkItems = [
  { text: "全て", value: undefined },
  { text: "確認済", value: EnumCheckApproval.Yes },
  { text: "未確認", value: EnumCheckApproval.No }
] as const;

const getAffiliationItems = async () => {
  const result = await $get<Shozoku[]>(Paths.approval.affiliation);
  if (result) affiliationItems.value = result;
};

const getEmployeeItems = async () => {
  const result = await $get<Item[]>(Paths.approval.employee);
  if (result) employeeItems.value = result;
};

const formatDate = (date: string) => {
  console.log("format", date);
  let returnDate = "";
  returnDate = DateTime.fromISO(date).toFormat("yyyy年MM月dd日");
  const d = DateTime.fromISO(date);
  // 曜日情報を作成
  const week = ["", "月", "火", "水", "木", "金", "土", "日"];
  const w = d.weekday;
  const weekday = "(" + week[w] + ")";
  returnDate += weekday;
  return returnDate;
  //return DateTime.fromISO(date).toFormat("yyyy年MM月dd日 HH:mm:ss");
};

const onClickRow = (_: unknown, slot: ClickRowSlot) => {
  slot.expand(!slot.isExpanded);
};

const onClear = () => {
  modelForm.value = {};
  emits("search");
};

const onSearch = () => emits("search");

const onCheck = (val: CheckApproval[]) =>
  emits(
    "check",
    val.map(e => e.recordId)
  );

onMounted(async () => {
  await Promise.all([getEmployeeItems(), getAffiliationItems()]);
});

return { __sfc: true,props, emits, selected, expanded, itemClass, modelForm, employeeItems, affiliationItems, defaultHeaders, computedHeaders, approvalItems, checkItems, getAffiliationItems, getEmployeeItems, formatDate, onClickRow, onClear, onSearch, onCheck, ApprovalChip, DatePicker, CheckApprovalChip }
}

})